import React from 'react';
import '../index.css';
import HeroPhoto from '..//Images/pfp.png';

function Home() {

  return (
    <main className={`container mx-auto px-4 py-6 ${'fade-in'}`}>
      <h1 className="text-4xl font-semibold text-indigo-600 mb-4 animate-fade-in-up mb-10 underline">Welcome to My Portfolio Website!</h1>
      <div className="flex items-center">
        <div className="rounded-full overflow-hidden w-1/2">
          <img src={HeroPhoto} alt="Profile" className="w-full h-full object-cover" />
        </div>
        <p className="text-indigo-600 font-semibold text-2xl ml-6 animate-fade-in-up font-afacad">
          Hello! My name is Abinand, I am undergraduate student at the University of Alberta, Double Majoring in Computing Science & Psychology.
          <br />
          <br />
          I am very interested in the fields of Software Development, Data Science, Human Computer Interaction, Neuroscience and Clinical Psychology.
        </p>
      </div>
    </main>
  );
}

export default Home;
